import { testimonials } from "../../../mocks/chiagua";

export default function Testimonials() {
  return (
    <section id="voice" className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-primary-100 text-sm font-semibold tracking-widest">VOICE OF USERS</span>
          <h2 className="font-heading text-3xl md:text-4xl text-background-50 mt-2">吃瓜群众怎么说</h2>
          <p className="text-primary-100/90 text-sm md:text-base mt-3">
            口碑来自一次次边播边聊、蹲到反转的现场体验。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-8 md:mt-10">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="bg-background-50/95 backdrop-blur rounded-2xl p-6 flex flex-col shadow-lg"
            >
              <div className="flex items-center gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`${i < t.rating ? "ri-star-fill" : "ri-star-line text-background-300"}`}
                  ></i>
                ))}
              </div>
              <blockquote className="text-foreground-800 text-sm md:text-base leading-relaxed mt-4 flex-1">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-5">
                <span className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center text-background-50 font-bold text-sm">
                  {t.name.slice(0, 1)}
                </span>
                <span className="text-foreground-900 font-medium text-sm">{t.name}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}